<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="权限名称">
          <Input placeholder="请输入" v-model="table.search.PrivilegeName"></Input>
        </FormItem>
        <FormItem label="权限类型">
          <Select v-model="table.search.PrivilegeType" clearable>
            <Option
              v-for="(item, index) in privilegeTypeSelect"
              :value="item.value"
              :key="index"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
    <!--操作区域-->
    <div>
      <Button class="mr-3" type="success" @click="search">查询</Button>
      <Button class="mr-3" type="primary" @click="addModal=true">新增</Button>
      <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      <Button class="mr-3" type="error" @click="syncMeunPrivilege">同步菜单权限</Button>
    </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal v-model="addModal" title="新增权限" :footer-hide="true" :closable="false">
      <privilegeadd @close="addModal=false" @loadData="search"></privilegeadd>
    </Modal>

    <!--更新-->
    <Modal v-model="editModal" title="更新权限" :footer-hide="true" :closable="false">
      <privilegeedit
        v-if="editModal"
        @close="editModal=false"
        @loadData="search"
        :editModelTemp="currentEditModel"
      ></privilegeedit>
    </Modal>

    <!--详情-->
    <Modal v-model="detailModal" title="权限详情" :footer-hide="true" :closable="false">
      <privilegedetail
        v-if="detailModal"
        @close="detailModal=false"
        :editModelTemp="currentEditModel"
      ></privilegedetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import privilegeadd from "../privilege/add.vue";
import privilegeedit from "../privilege/edit.vue";
import privilegedetail from "../privilege/detail.vue";

export default {
  components: { DataTable, privilegeadd, privilegeedit, privilegedetail },
  data: function () {
    return {
      currentEditModel: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      selectionData: [],
      privilegeTypeSelect: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "权限名称", key: "privilegeName" },
          { title: "权限值", key: "privilegeCode" },
          {
            title: "权限类型",
            key: "privilegeType",
            render: (h, value) => {
              return h(
                "div",
                this.$common.getEnumDescription(
                  "privilegeType",
                  value.row.privilegeType
                )
              );
            },
          },
          {
            title: "创建时间",
            key: "createTime",
            render: (h, value) => {
              return h("div", this.$common.parseDate(value.row.createTime));
            },
          },
          {
            title: "操作",
            width: "200px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.privilegeID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "privilege/getListPage",
        search: {
          PrivilegeName: "",
          PrivilegeType: "",
        },
      },
    };
  },

  created: function () {
    this.privilegeTypeSelect = this.$common.getJsonData("privilegeType");
  },
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {},

    toEdit: function (data) {
      this.editModal = true;
      this.currentEditModel = JSON.parse(JSON.stringify(data));
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该权限吗？",
        mask: false,
        onOk: () => {
          this.$api.post(`/privilege/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.privilegeID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api.post(`/privilege/deleteBatch?ids=${_ids}`).then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
          },
        });
      }
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },

    //同步菜单权限
    syncMeunPrivilege() {
      var routes = this.$router.options.routes[0].children;
      var menuList = [];
      for (let item of routes) {
        if (item.children) {
          for (let m of item.children) {
            if (m.menu == true) {
              let obj = {
                PrivilegeName: m.name,
                PrivilegeCode: m.meta.permissionCode,
              };
              menuList.push(obj);
            }
          }
        }
      }
      this.$api.post(`/privilege/syncMeunPrivilege`, menuList).then((rsp) => {
        if (rsp != false) {
          this.$Message.success("同步成功");
          this.search();
        }
      });
    },
  },
};
</script>
<style scoped>
</style>